// 爆料网 首页内容数据源（虚构演示案例，用于展示信息整合与追踪能力）

export const brand = {
  name: "爆料网",
  slogan: "把每件事讲透，吃瓜不吃糊涂瓜",
  desc: "聚焦中文互联网热点事件的信息整合门户：以「来龙去脉 + 完整时间线」为核心，坚持来源标注、交叉验证与公开辟谣。",
};

export const navLinks = [
  { id: "hot", label: "今日热榜" },
  { id: "feed", label: "最新瓜料" },
  { id: "full", label: "事件全记录" },
  { id: "deep", label: "深度解析" },
  { id: "topic", label: "专题栏目" },
  { id: "guide", label: "吃瓜指南" },
  { id: "about", label: "关于我们" },
];

export const tickerItems = [
  "【进展】某头部茶饮「配料表之争」当事人晒出送检报告，事件第 4 轮反转来了",
  "【复盘】直播电商「年货节翻车」全记录已更新至道歉之后的最新动作",
  "【辟谣】网传「某顶流直播数据造假截图」经核对为旧图移花接木，勿再转发",
  "【独家】MCN 与主播解约风波背后，佣金分层协议完整还原上线",
  "【提醒】新一轮「改名复出」公关案例盘点：三步走话术逐条拆解",
];

export const hero = {
  kick: "独家·事件全记录",
  overline: "热榜第一 · 已跟踪 168 小时",
  title: "直播电商「年货节翻车」事件全记录",
  lead: "从一条被剪断的直播预告，到铺天盖地的退货截图，再到深夜道歉与后续整改——我们把这场持续一周的舆情风暴，按时间、信源与关键证据逐帧还原，让你一次看清来龙去脉。",
  tags: ["直播电商", "舆情复盘", "时间线", "已核实 87%"],
  meta: "7.2 万阅读 · 3240 条讨论 · 12 处信源标注",
  image:
    "https://readdy.ai/api/search-image?query=live_streaming_ecommerce_studio_behind_the_scenes_with_ring_lights_and_product_boxes_arranged_on_dark_wooden_table_warm_amber_and_terracotta_editorial_cinematic_lighting_documentary_mood_shallow_depth_of_field_high_detail_muted_warm_tone_palette_modern_chinese_ecommerce_office&width=1600&height=900&seq=hero-master-x1&orientation=landscape",
};

export const hotRank = [
  { title: "年货节翻车：从预告被剪到深夜道歉的 48 小时", heat: 982.4, hot: true, tag: "直播电商" },
  { title: "茶饮「真茶之战」：一张配料表引发的 4 轮反转", heat: 876.1, hot: true, tag: "消费" },
  { title: "顶流 MCN 与主播解约风波：佣金分成层层拆解", heat: 742.9, hot: true, tag: "网红江湖" },
  { title: "「反向带货」爆火：批评如何被做成了流量生意", heat: 655.3, hot: false, tag: "行业观察" },
  { title: "翻车网红「复出」三步走：道歉·改名·重建人设", heat: 588.7, hot: false, tag: "娱乐八卦" },
  { title: "电竞转会大瓜：阴阳合同与签字费时间线还原", heat: 512.6, hot: false, tag: "电竞前线" },
  { title: "一张「内部聊天截图」为何能骗过半个热搜", heat: 473.8, hot: false, tag: "反扒辟谣" },
  { title: "私域团购「野性促销」：200 元羽绒服背后的成本局", heat: 398.2, hot: false, tag: "消费观察" },
  { title: "虚拟主播解约风波：违约金条款里的文字游戏", heat: 356.9, hot: false, tag: "饭圈观察" },
  { title: "「素人爆料」真假难辨：我们如何给信息分层定级", heat: 301.4, hot: false, tag: "方法论" },
];

export const hotFlash = [
  "一张截图被二次传播 3.2 万次，原博主已置顶更正声明",
  "当事人直播间临时改名，粉丝量 24 小时波动逾 40 万",
  "品牌方首度回应：将联合第三方机构复核主播选品流程",
  "业内律师解读：佣金分层协议中「代扣代缴」的边界在哪里",
  "平台上线「争议内容标注」，疑似相关稿件已打上核查标签",
];

export const feedTabs = [
  { key: "all", label: "全部" },
  { key: "mcn", label: "网红江湖" },
  { key: "live", label: "直播带货" },
  { key: "consume", label: "消费观察" },
  { key: "ent", label: "娱乐八卦" },
  { key: "internet", label: "互联网" },
];

export const feedFeatures = [
  {
    id: "f1",
    cat: "直播带货",
    catKey: "live",
    title: "预告被剪成 3 秒：一次「年货翻车」为何能上四个热搜",
    summary:
      "我们回看了整场直播的切片、后台公告与品牌方沟通记录，把「剪预告—上链接—售罄—全网断货截图—深夜道歉」的链条逐段对齐，找出真正引发情绪的节点。",
    views: "7.2 万",
    comments: 3240,
    time: "2026.09.04 21:40",
    img:
      "https://readdy.ai/api/search-image?query=backstage_of_an_ecommerce_live_streaming_room_with_warm_ring_light_and_mobile_phone_tripod_and_tangled_cable_boxes_warm_amber_terracotta_editorial_documentary_lighting_high_detail_muted_warm_palette_cinematic&width=800&height=600&seq=card-live-x1&orientation=landscape",
  },
  {
    id: "f2",
    cat: "消费观察",
    catKey: "consume",
    title: "「真茶」还是「调制茶」：配料表到底该怎么读",
    summary:
      "一张配料表的争议背后，是行业现行标签规则的空白。我们把国标条目、第三方检测口径与品牌回应做成对照表，帮你分辨「营销话术」与「客观事实」。",
    views: "5.8 万",
    comments: 2187,
    time: "2026.09.04 18:12",
    img:
      "https://readdy.ai/api/search-image?query=minimalist_milk_tea_cup_and_raw_tea_leaves_on_warm_beige_ceramic_plate_with_receipt_and_specification_sheet_warm_soft_editorial_photography_high_detail_terracotta_amber_tone_food_product_style&width=800&height=600&seq=card-tea-x1&orientation=landscape",
  },
  {
    id: "f3",
    cat: "网红江湖",
    catKey: "mcn",
    title: "解约风波调查：佣金分层的「阴阳合同」与法律边界",
    summary:
      "把双方的公开声明、主播直播切片与既往合作案例摆在一起，我们从税务与合同两个角度，拆解「分成比例到底几几开」这个瓜的核心争议点。",
    views: "6.3 万",
    comments: 2988,
    time: "2026.09.03 22:05",
    img:
      "https://readdy.ai/api/search-image?query=modern_chinese_media_agency_office_with_contract_documents_and_laptop_and_blurred_people_warm_amber_and_terracotta_editorial_lighting_high_detail_documentary_mood_muted_warm_palette&width=800&height=600&seq=card-office-x1&orientation=landscape",
  },
  {
    id: "f4",
    cat: "反扒辟谣",
    catKey: "all",
    title: "「内部聊天截图」鉴定：EXIF、字体与像素如何露馅",
    summary:
      "谣言往往从一张「来路不明」的截图开始。我们复盘了近期几条高热度假截图的破绽点，教你在三秒内先问出最关键的三个核实问题。",
    views: "4.4 万",
    comments: 1531,
    time: "2026.09.03 15:20",
    img:
      "https://readdy.ai/api/search-image?query=close_up_of_a_hand_holding_smartphone_with_chat_screen_and_magnifier_and_newspaper_warm_desktop_lighting_editorial_documentary_style_high_detail_amber_terracotta_muted_tone_tech&width=800&height=600&seq=card-phone-x1&orientation=landscape",
  },
];

export const feedTopList = [
  { cat: "互联网", title: "平台「争议标注」上线一周，覆盖稿件已达 3.6 万条", time: "09.04", views: "9.1 万" },
  { cat: "娱乐八卦", title: "「道歉模板」被群嘲：情绪话术与整改动作的落差在哪", time: "09.04", views: "8.6 万" },
  { cat: "消费观察", title: "200 元羽绒服刷屏：成本、运费险与「到手价」全拆解", time: "09.03", views: "7.9 万" },
  { cat: "饭圈观察", title: "粉丝集资应援的灰色地带：明细公示为何常缺位", time: "09.03", views: "6.8 万" },
  { cat: "直播带货", title: "「退款潮」数据解读：从退款率曲线看一场翻车舆情", time: "09.02", views: "6.2 万" },
];

export const timeline = {
  kick: "本期 · 事件全记录",
  title: "一次舆情如何走过 6 个阶段",
  subtitle:
    "以下按时间推进还原某虚拟人气主播解约风波的全过程。每个阶段都标注信源类型与核实状态，仅保留有据可查的节点，传闻类信息单列「待核实」层。",
  eventName: "虚拟主播「阿乐」解约风波",
  stageList: [
    { name: "导火索", value: "3 条", desc: "停更公告与旧片段" },
    { name: "引爆点", value: "24 小时", desc: "热搜持续时长" },
    { name: "关键信源", value: "11 处", desc: "含平台公告/截图" },
    { name: "已核实", value: "78%", desc: "分层标注完成" },
  ],
  stages: [
    {
      phase: "序 · 信号",
      date: "第 1-2 天",
      tone: "平静",
      points: [
        "运营账号连续 3 天未按惯例更新，粉丝在超话发起疑问帖",
        "主播小号被发现点赞了一条关于「合约到期」的模糊评论",
        "此时仅属于「异常信号」，尚不足以构成任何定论",
      ],
    },
    {
      phase: "燃 · 引爆",
      date: "第 3 天",
      tone: "高热",
      points: [
        "一条疑似「内部排期表」截图开始在小范围流传",
        "随后主播工作室发布停播公告，措辞含「身体原因」字样",
        "情绪在数小时内被放大，相关话题冲上多平台热搜前排",
      ],
    },
    {
      phase: "吵 · 分裂",
      date: "第 4-6 天",
      tone: "混乱",
      points: [
        "「违约金惊人」「被雪藏」等传闻满天飞，但均缺直接证据",
        "运营方与主播先后发声，说法在「合同中止」与「友好协商」间反复",
        "我们按信源将信息分为「已证实 / 待核实 / 明确存疑」三层",
      ],
    },
    {
      phase: "缓 · 澄清",
      date: "第 7-10 天",
      tone: "降温",
      points: [
        "平台出面说明解约程序合规，违约金条款属双方约定",
        "主播本人开播简短回应，核心口径与运营方趋于一致",
        "热度回落，但评论区仍残留大量未经核实的情绪化传言",
      ],
    },
    {
      phase: "止 · 复盘",
      date: "第 11 天至今",
      tone: "沉淀",
      points: [
        "我们汇总全部公开信源，剔除重复与伪造，形成最终时间线",
        "新增「避坑提示」：如何在传播中快速识别二手三手截图",
        "本篇将持续跟进后续补强证据，若有更新会在顶栏提示",
      ],
    },
  ],
};

export const specials = [
  {
    id: "s1",
    cat: "行业深扒",
    title: "直播带货的「三重话术」：为什么翻车总在相似处",
    desc: "从选品话术、砍价话术到「最后 100 单」倒计时，我们拆解一套可复用的底层叙事，解释观众情绪如何在 3 分钟内被点燃。",
    read: "约 12 分钟",
    count: "308 条互动",
    img:
      "https://readdy.ai/api/search-image?query=moody_ecommerce_warehouse_shelves_with_returned_parcels_and_delivery_boxes_warm_amber_terracotta_editorial_documentary_lighting_high_detail_muted_warm_palette_cinematic_composition&width=1200&height=800&seq=sp-live-x1&orientation=landscape",
  },
  {
    id: "s2",
    cat: "舆情方法论",
    title: "一份合格的「事件全记录」应该包含哪几层",
    desc: "时间线、信源清单、核实状态与已知空白——我们把内部整理信息的四层框架公开，让每个人都能给自己的瓜「排雷」。",
    read: "约 8 分钟",
    count: "521 条互动",
    img:
      "https://readdy.ai/api/search-image?query=journalists_research_desk_with_timeline_notes_printed_papers_and_pinned_photos_on_warm_wooden_table_amber_editorial_documentary_lighting_high_detail_cinematic_muted_warm_palette&width=1200&height=800&seq=sp-invest-x1&orientation=landscape",
  },
  {
    id: "s3",
    cat: "饭圈观察",
    title: "应援与集资之间：粉丝经济里的灰色安全区",
    desc: "通过对公开明细与平台规则的梳理，我们尝试把「合理应援」与「高风险集资」划出一条尽量清楚的线。",
    read: "约 10 分钟",
    count: "196 条互动",
    img:
      "https://readdy.ai/api/search-image?query=crowd_in_concert_holding_glow_sticks_with_soft_bokeh_lights_warm_amber_and_terracotta_editorial_documentary_photography_high_detail_cinematic_muted_warm_tone&width=1200&height=800&seq=sp-fan-x1&orientation=landscape",
  },
];

export const categories = [
  { name: "行业风云", count: 128, desc: "品牌、平台与机构博弈复盘", icon: "ri-building-2-line", hot: true },
  { name: "网红江湖", count: 216, desc: "主播与机构的起落与解约", icon: "ri-vip-crown-2-line", hot: true },
  { name: "直播带货", count: 173, desc: "话术、选品与翻车全记录", icon: "ri-live-line", hot: true },
  { name: "娱乐八卦", count: 241, desc: "影视综与艺人动态追踪", icon: "ri-mic-2-line", hot: false },
  { name: "互联网", count: 164, desc: "产品、平台与规则变动", icon: "ri-global-line", hot: false },
  { name: "消费观察", count: 97, desc: "商品成本与消费套路拆解", icon: "ri-price-tag-3-line", hot: false },
  { name: "饭圈观察", count: 88, desc: "粉丝经济与社群现象", icon: "ri-heart-3-line", hot: false },
  { name: "反扒辟谣", count: 76, desc: "识别假截图与移花接木", icon: "ri-shield-check-line", hot: false },
];

export const faqs = [
  {
    q: "爆料网的内容来源可靠吗？我担心看到的是没依据的传言。",
    a: "这是最核心的问题。我们坚持「来源标注 + 交叉验证」两条底线：每个事件的结论都尽量给出公告原文、公开数据或可信截图作为支撑；暂时拿不准的信息会单列「待核实」层，绝不会和已证实事混为一谈。你可以在文章顶部看到实时的「已核实」比例。",
  },
  {
    q: "那你们如何避免自己变成谣言放大器？",
    a: "我们在内部对所有信源做三层分级：已证实、待核实、明确存疑。明确存疑的内容原则上只做「破拆科普」而非转述传播；一旦出现官方更正，会第一时间在事件顶栏更新「进展」并保留更正记录，方便读者看到信息是如何被修订的。",
  },
  {
    q: "我想提供线索或投稿，应该怎么做？",
    a: "欢迎通过页脚邮箱或各平台同名账号与我们联系。为方便核实，请在提供材料时尽量附上公开链接或可匿名处理的原始截图，并说明你的身份立场（当事方、亲历者或旁观者）。所有来料在核实前均不会被直接引用。",
  },
  {
    q: "「事件时间线」是怎么整理出来的？",
    a: "我们以「时间」为主轴，把公开公告、媒体报道、平台规则与可验证截图按先后顺序排列，并为每个节点标注信源类型。这样你既能看清节奏，也能看出哪些信息先出现、哪些后澄清——而节奏本身往往就是理解舆论的关键。",
  },
  {
    q: "为什么有的文章会反复出现「进展更新」？",
    a: "热点事件的最大特点是信息会不断变化。为尊重事实，我们对仍在发酵的事件采取「追踪式更新」，把新公告、更正或当事人回应追加到时间线末尾，并在顶栏明确标注更新日期。你可以把这类文章当作一个持续维护的「活档案」。",
  },
  {
    q: "想第一时间看到更新，有哪些订阅方式？",
    a: "你可以在页脚留下邮箱订阅「热点速递」，我们会在重大事件出现进展或关键澄清时发送一封摘要，不会频繁打扰。此外，各平台同名账号也会同步关键进展，欢迎关注。",
  },
];

export const reviews = [
  {
    quote: "能把一张「真茶之争」的配料表争议讲成对照表，看得出是下了功夫核对的，比单纯看图说话强太多。",
    who: "一位常在评论区追更的读者",
  },
  {
    quote: "最喜欢它的信源分层，哪些是实锤哪些还没谱一眼就明白，吃瓜也能吃得有安全感。",
    who: "互联网行业从业者",
  },
  {
    quote: "跟踪式的「全记录」很实用，事件吵到第三天打开它，半小时就能补上前面所有错过的时间线。",
    who: "关注直播电商的普通用户",
  },
];

export const aboutStats = [
  { num: "8", unit: "个", label: "常设栏目" },
  { num: "1200+", unit: "", label: "归档事件档案" },
  { num: "96%", unit: "", label: "重大事件有更正留痕" },
  { num: "3 层", unit: "", label: "信源分级标准" },
];

export const principles = [
  { icon: "ri-focus-3-line", title: "时间线优先", desc: "把事件放回时间轴里看，顺序往往比结论更能说明问题。" },
  { icon: "ri-flag-line", title: "信源透明", desc: "每条关键结论尽量给出处，待核实内容单列，不与实锤混排。" },
  { icon: "ri-error-warning-line", title: "纠错留痕", desc: "有更正不删帖、不静默，保留修订过程本身就是一种负责。" },
];

export const footerCols = [
  {
    title: "快速导航",
    links: [
      { id: "#hot", label: "今日热榜" },
      { id: "#full", label: "事件全记录" },
      { id: "#deep", label: "深度解析" },
      { id: "#topic", label: "专题栏目" },
      { id: "#guide", label: "吃瓜指南" },
    ],
  },
  {
    title: "内容原则",
    links: [
      { id: "#about", label: "关于我们" },
      { id: "#guide", label: "信息分层标准" },
      { id: "#about", label: "纠错与更新机制" },
      { id: "#about", label: "联系我们" },
    ],
  },
];

export const contactEmail = "hello@baoliao.example.com";
export const formUrl = "https://readdy.ai/api/form/dadvthrep053ijub1650";